module.exports = __webpack_public_path__ + "static/media/Swiss721BT-BoldCondensed.bbd26f4c.woff";